import React from 'react'
import { useDrop } from 'react-dnd'
import { Button } from '@dhis2/ui'

const HigherLevelObjectiveDropZone = ({ onDrop, selectedObjective, onClear }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'higherLevelObjective',
    drop: (item) => onDrop(item.objective),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }))

  return (
    <div
          ref={drop}
          style={{
            padding: '24px',
            border: `2px dashed ${
              isOver ? '#2ecc71' : selectedObjective ? '#27ae60' : '#cfd8dc'
            }`,
            borderRadius: '16px',
            background: isOver
              ? 'linear-gradient(135deg, #d9fdd3, #f1fff1)'
              : selectedObjective
              ? 'linear-gradient(135deg, #ecfff4, #f6fff9)'
              : '#fafafa',
            textAlign: 'center',
            marginBottom: '24px',
            transition: 'all 0.3s ease',
            minHeight: '150px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: isOver
              ? '0 6px 16px rgba(46, 204, 113, 0.25)'
              : '0 2px 8px rgba(0,0,0,0.08)',
            cursor: 'pointer',
            transform: isOver ? 'scale(1.02)' : 'scale(1)',
          }}
        >

      {selectedObjective ? (
        <div style={{ textAlign: 'center' }}>
          <h4
            style={{
              margin: '0 0 10px 0',
              color: '#27ae60',
              fontWeight: '600',
            }}
          >
            ✅ Higher-Level Objective Selected
          </h4>
          <p
            style={{
              margin: '0 0 16px 0',
              fontWeight: 'bold',
              fontSize: '1rem',
              color: '#2c3e50',
            }}
          >
            {selectedObjective.name}
          </p>
          <Button small destructive onClick={onClear}>
            Change Objective
          </Button>
        </div>
      ) : (
        <div>
          <p
            style={{
              margin: '0 0 8px 0',
              fontWeight: '500',
              color: isOver ? '#2ecc71' : '#7f8c8d',
              fontSize: '1rem',
            }}
          >
            {isOver
              ? '🎯 Drop your higher-level objective here'
              : '📌 Drag a higher-level objective here to align'}
          </p>
          <p
            style={{
              margin: 0,
              fontSize: '0.85rem',
              color: '#95a5a6',
              fontStyle: 'italic',
            }}
          >
            or click on a higher-level objective card to select
          </p>
        </div>
      )}
    </div>
  )
}

export default HigherLevelObjectiveDropZone
